import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MgButtonModule } from '@app/src/app/button';
import { StepIndicatorModule } from '@app/src/app/components/StepIndicator';
import { DefaultParentGroupPickerModule } from '@app/src/app/groups/containers/DefaultParentGroupPicker';
import { PermissionsModule } from '@app/src/app/permissions';

import { WelcomeDistrictSchoolSelectComponent } from './WelcomeDistrictSchoolSelect.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgButtonModule,
    StepIndicatorModule,
    DefaultParentGroupPickerModule,
    PermissionsModule,

    // External dependencies
    CommonModule,
  ],
  declarations: [WelcomeDistrictSchoolSelectComponent],
  exports: [WelcomeDistrictSchoolSelectComponent],
})
export class WelcomeDistrictSchoolSelectModule {}
